import {useQuery} from "@tanstack/react-query";
import axiosManager from "../services/axiosManager";

export const useGetStartDates = () => {
    const {
        isFetching: isLoading, data: startDates, error,
    } = useQuery({
        queryKey: ["startdates"],
        queryFn: () => axiosManager.get$("startdates").then((response) => response?.data),
        initialData: [],
        retry: 0,
    });

    const startDatesOptions = (startDates || []).map((item) => ({value: item.startDate, label: item.displayName}));

    return {
        isLoading, startDates, error, startDatesOptions,
    };

};
